import React from "react";
import NF from ".././assets/all-images/cars-img/NF.png";

const NotFound = () => {
  return (
    <div className="container mx-auto mt-2 flex flex-col items-center">
      <h6 className="text-4xl font-bold mb-4">Page Not Found</h6>
      <img
        src={NF}
        alt="Not Found"
        className="w-1/2 md:w-1/3 lg:w-1/4"
      />
      <p className="text-lg">
        Oops! The page you are looking for does not exist.
      </p>
    </div>
  );
};

export default NotFound;